import React, {useState, useEffect} from 'react';

import { Link } from "react-router-dom";

import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';

var bestDealsNum = Math.floor((Math.random()*2))+1;
function About(props) {

  const [shiftImage1Style, setShiftImage1Style] = useState({backgroundPosition: 'right -10px'});

  // CMS-managed carousel slides. Populated from /api/slides at mount; if the
  // request fails (or returns nothing) we silently fall back to the hardcoded
  // slides below, so the carousel always shows something.
  const [cmsSlides, setCmsSlides] = useState([]);
  useEffect(() => {
    var aborted = false;
    fetch('/api/slides', { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : { slides: [] }; })
      .then(function (j) { if (!aborted && j && Array.isArray(j.slides)) setCmsSlides(j.slides); })
      .catch(function () { /* keep fallback slides */ });
    return function () { aborted = true; };
  }, []);

  window.addEventListener("scroll", (event) => {
    if(window !== undefined) {
      let scroll = window.scrollY;
      //console.log(scroll);
      setShiftImage1Style({backgroundPosition: 'right '+(-scroll*0.075-10)+'px'});
    }
  });

  var imgSize = 120;

  return (
    <div className="page">
      {cmsSlides.length > 0 && (
      <Carousel>

        {cmsSlides.map(function (s) {
          // Text container = the polygon's bounding rectangle. Earlier
          // versions of this component tried to flow text inside the polygon
          // shape itself via two shape-outside floats — the math is correct
          // (proved against the live API polygons) but the layout was
          // fragile: two 100%×100% floats stack vertically before the
          // shape-outside is even consulted, so text frequently ended up
          // squeezed below them or rendered into a zero-height box. Reverted
          // to a simple rectangle render that *always* shows text. The
          // colored shape behind the rectangle is part of the background
          // JPEG so the visual effect is similar; only the text-flow-around-
          // angled-edges nicety is lost.
          var poly = (s.textPolygon && s.textPolygon.length >= 3) ? s.textPolygon : null;
          var box = s.textBox || { left: 55, top: 15, width: 40, height: 70 };
          var align = s.textAlign || 'center';
          var xs = poly ? poly.map(function (p) { return p.x; }) : [box.left, box.left + box.width];
          var ys = poly ? poly.map(function (p) { return p.y; }) : [box.top,  box.top + box.height];
          var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
          var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
          var bbW = maxX - minX, bbH = maxY - minY;

          var containerStyle = {
            position: 'absolute',
            left:   minX + '%',
            top:    minY + '%',
            width:  bbW + '%',
            height: bbH + '%',
            overflow: 'hidden',
            boxSizing: 'border-box',
            textAlign: align,
            // Center the headline + subhead + CTA block vertically inside
            // the rectangle. The (optionally bottom-anchored) tagline is
            // absolute-positioned and sits independently below.
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center',
            padding: '8px',
          };
          // Express font-size in container-query width units (cqw) so the
          // text scales with the actual carousel width. The 0.7 multiplier
          // brings the live carousel's absolute size down to roughly match
          // what the operator sees in the in-CMS preview thumbnail — the
          // raw cqw math from the 1024-canvas reference looked correct
          // proportionally but overshoots on wide viewports because the
          // live carousel has a different aspect ratio than the design
          // canvas. 0.7 is the empirical adjustment the operator requested.
          function pxToCqw(px) { return ((px / 1024) * 100 * 0.7).toFixed(2) + 'cqw'; }
          var headlineSize = pxToCqw(s.headlineSize || 96);
          var subheadSize  = pxToCqw(s.subheadSize  || 44);
          var taglineSize  = pxToCqw(s.taglineSize  || Math.round((s.subheadSize || 44) * 0.6));
          var taglineBottom = s.taglineAnchor === 'bottom';
          var headlineStyle = {
            color: s.headlineColor || '#fbbf24',
            margin: 0, lineHeight: 1.05,
            fontSize: headlineSize,
          };
          var subheadStyle  = {
            color: s.subheadColor  || '#ffffff',
            margin: '12px 0 0', lineHeight: 1.25,
            fontSize: subheadSize,
          };
          var taglineStyle = taglineBottom ? {
            // Anchored mode: pin to the bottom of the text-box polygon's
            // bounding rectangle. Removed from normal flow so headline +
            // subhead + CTA still center above.
            position: 'absolute',
            left: 0, right: 0, bottom: 0,
            color: s.taglineColor || s.subheadColor || '#ffffff',
            margin: 0, lineHeight: 1.2,
            fontSize: taglineSize,
            letterSpacing: '0.04em',
            textAlign: align,
            paddingLeft: '8px', paddingRight: '8px',
          } : {
            color: s.taglineColor || s.subheadColor || '#ffffff',
            margin: '10px 0 0', lineHeight: 1.2,
            fontSize: taglineSize,
            letterSpacing: '0.04em',
          };
          var ctaBgColor = s.ctaBgColor || s.headlineColor || '#fbbf24';
          var ctaTextColor = s.ctaTextColor ||
            (String(ctaBgColor).toLowerCase() === '#fbbf24' ? '#273a63' : (s.subheadColor || '#ffffff'));
          var btnStyle = {
            display: 'inline-block',
            position: 'relative',
            zIndex: 20,
            background: ctaBgColor,
            color: ctaTextColor,
            padding: '10px 22px',
            borderRadius: '8px',
            fontWeight: 700,
            textDecoration: 'none',
            marginTop: 16,
          };
          return (
            <Carousel.Item key={'cms-' + s.id}>
              <div className="carousel_item" style={{backgroundImage: 'url("' + s.image + '")', position: 'relative'}}>
                <div className="cms_carousel_textbox" style={containerStyle}>
                  {s.headline ? <h2 className="yellow_heading_caro" style={headlineStyle}>{s.headline}</h2> : null}
                  {s.subhead ? <h3 style={subheadStyle}>{s.subhead}</h3> : null}
                  {s.ctaLabel ? <a href={s.ctaUrl || s.linkUrl || '/plans'} style={btnStyle}>{s.ctaLabel}</a> : null}
                  {s.tagline ? <p style={taglineStyle}>{s.tagline}</p> : null}
                </div>
                <div className="square_ad_image">
                  <img src={s.square} width="100%" alt={s.name || s.headline || ''} />
                </div>
              </div>
            </Carousel.Item>
          );
        })}

      </Carousel>
      )}

      <div className="text_block_white">
        <h3>Last Mile Wireless Internet in Saskatchewan</h3>
        <p>Established in 2022, Last Mountain Wireless Inc. was created to provide cutting edge wireless Internet access and outstanding customer service to the Last Mountain area in Central Saskatchewan.</p>
      </div>
      <div className="text_block_black">

        <h3>AirFiber Internet</h3>
        <img src="img/ltu-xr_on_black.png" style={{"float": "right"}} />
        <h5><span className="brand_color_text">250+ Mbps Download Speeds</span></h5>
        <p>We use the latest fixed wireless technologies to bring <b>fiber optic internet speeds</b> from the tower to your home or business.</p>

        <p><i><b>Live rural</b>, but stay connected.</i></p>
        <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="lg" active>View our Internet Plans</Button><br/>
      </div>
      <div className="text_block_blue" id="service_communities">
        <h3>Availability</h3>

        <p>The following is a list of communities and surrounding areas where we've currently established service:</p>

        <div className="serving">
          <h5><span className="brand_color_text">Strasbourg</span></h5>
          <img src="img/serving_strasbourg.png" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>

        <div className="serving">
          <h5><span className="brand_color_text">Duval</span></h5>
          <img src="img/serving_duval.png" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Govan</span></h5>
          <img src="img/serving_govan.jpg" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Uhl's Bay</span></h5>
          <img src="img/serving_img_soon.jpg" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Collingwood</span></h5>
          <img src="img/serving_collingwood.png" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Island View</span></h5>
          <img src="img/serving_img_soon.jpg" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Colesdale Park</span></h5>
          <img src="img/serving_img_soon.jpg" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Spring Bay</span></h5>
          <img src="img/serving_img_soon.jpg" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Alice Beach</span></h5>
          <img src="img/serving_alicebeach.png" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Wee Too Beach</span></h5>
          <img src="img/serving_wetoobeach.png" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
        <div className="serving">
          <h5><span className="brand_color_text">Sarnia Beach</span></h5>
          <img src="img/serving_sarniabeach.png" width={imgSize} /><br/><br/>
          <Button onClick={() => { window.open('/plans', '_self')}} variant="warning" size="sm" active>Available Now!</Button>
          <p></p>
        </div>
{/*        <br/><br/>
        <h5>But my community isn't on the list!</h5>
        <p><i>We're doing everything we can to build out to you as quickly as possible. We will update this list as we continue to grow, please check back often!</i></p>
*/}

      </div>

    </div>);

}
  
export default About;
